import { Link, Outlet, createFileRoute, useRouterState } from '@tanstack/react-router'
import { cx } from '@/lib/clases'

export const Route = createFileRoute('/sistema')({
  component: CatalogoDelSistema,
})

const SECCIONES = [
  { a: '/sistema', etiqueta: 'Fundamentos', exacta: true },
  { a: '/sistema/tabla', etiqueta: 'Tabla de datos', exacta: false },
  { a: '/sistema/formularios', etiqueta: 'Formularios', exacta: false },
  { a: '/sistema/retroalimentacion', etiqueta: 'Estados y errores', exacta: false },
  { a: '/sistema/superposiciones', etiqueta: 'Paneles y confirmaciones', exacta: false },
] as const

/**
 * Catálogo del sistema de diseño.
 *
 * **No es la aplicación.** Es lo que permite revisar los cimientos —cada
 * componente en sus cuatro estados y las tres densidades— sin haber construido
 * ninguna pantalla real, y lo que evita que la primera pantalla invente
 * decisiones que ya están tomadas.
 */
function CatalogoDelSistema() {
  const rutaActual = useRouterState({ select: (estado) => estado.location.pathname })

  return (
    <div className="flex flex-col gap-6">
      <header className="flex flex-col gap-1">
        <h1 className="text-pantalla text-gris-900">Sistema de diseño</h1>
        <p className="max-w-[720px] text-cuerpo text-gris-600">
          Los componentes base tal como se usan. Esto no es la aplicación: es el catálogo con el que
          se revisa que una pantalla nueva no invente nada. Los tokens viven en{' '}
          <code className="mono text-gris-900">src/estilos/tokens.css</code> y son la única fuente.
        </p>
      </header>

      <nav aria-label="Secciones del catálogo" className="border-b border-gris-300">
        <ul className="flex flex-wrap gap-1">
          {SECCIONES.map((seccion) => {
            const activa = seccion.exacta ? rutaActual === seccion.a : rutaActual.startsWith(seccion.a)
            return (
              <li key={seccion.a}>
                <Link
                  to={seccion.a}
                  aria-current={activa ? 'page' : undefined}
                  className={cx(
                    'inline-flex h-[var(--alto-control)] items-center border-b-2 px-3 text-cuerpo',
                    activa
                      ? 'border-marca font-medium text-marca'
                      : 'border-transparent text-gris-600 hover:text-gris-900',
                  )}
                >
                  {seccion.etiqueta}
                </Link>
              </li>
            )
          })}
        </ul>
      </nav>

      <Outlet />
    </div>
  )
}
